<template>
  <div>
    <ServerError v-if="ServerError" />
    <PageLoader v-bind:storage="appLoading" />
    <v-snackbar v-model="showSnackBar" color="#3CB043" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="addressAddDialog" width="700" persistent>
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-card tile flat>
            <v-layout
              wrap
              justify-center
              px-8
              py-5
              style="background-color: #b6b6b626"
            >
              <v-flex xs11 text-left>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #393939;
                  "
                >
                  New Address
                </span>
              </v-flex>
              <v-flex xs1>
                <v-icon @click="addressAddDialog = false" color="#000000"
                  >mdi-close</v-icon
                >
              </v-flex>
            </v-layout>
            <v-layout
              wrap
              justify-center
              pt-8
              px-5
              style="
                font-size: 14px;
                color: #1f1f1f;
                font-family: RobotoRegular;
              "
            >
              <v-flex xs12 sm6 text-left px-2>
                <span>First Name </span>
                <v-text-field
                  ref="firstname"
                  background-color="#F5F5F5"
                  solo
                  placeholder="First Name"
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="fstname"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span>Last Name </span>
                <v-text-field
                  ref="firstname"
                  background-color="#F5F5F5"
                  solo
                  placeholder="Last Name"
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="lstname"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 text-left px-2>
                <span> Email </span>
                <v-text-field
                  ref="email"
                  placeholder="Email"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 text-left px-2>
                <span>Address </span>
                <v-text-field
                  ref="streetAddress"
                  placeholder="Address"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="address"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span>Pincode</span>
                <v-text-field
                  ref="pincode"
                  placeholder="Pincode"
                  background-color="#F5F5F5"
                  solo
                  flat
                  type="number"
                  dense
                  :rules="[rules.required]"
                  v-model="pincode"
                  @change="getPinCode"
                ></v-text-field>
                <!-- <v-text-field
                  ref="pincode"
                  placeholder="Pincode"
                  background-color="#F5F5F5"
                  solo
                  flat
                  type="number"
                  dense
                  :rules="[rules.required]"
                  v-model="pincode"
                 
                ></v-text-field> -->
              </v-flex>
              
              <v-flex xs12 sm6 text-left px-2>
                <span>District</span>
                <v-text-field
                  ref="district"
                  placeholder="District"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="district"
            
                ></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 text-left px-2>
                <span>State</span>
                <v-text-field
                  ref="state"
                  placeholder="State"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="state"
             
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span> Country </span>
                <v-text-field
                  ref="country"
                  placeholder="Country"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="country"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span> Landmark </span>
                <v-text-field
                  ref="landmark"
                  placeholder="Landmark"
                  background-color="#F5F5F5"
                  solo
                  flat
                 
                  dense
                  :rules="[rules.required]"
                  v-model="landmark"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span> Phone </span>
                <v-text-field
                  ref="phone"
                  placeholder="Phone"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  type="number"
                  :rules="[rules.required]"
                  v-model="mobileNum"
                ></v-text-field>
              </v-flex>
              
            </v-layout>
            <v-layout wrap justify-center py-5>
              <v-flex xs4 px-2 text-right>
                <v-btn
                  :ripple="false"
                  depressed
                  block
                  rounded
                  color="#444645"
                  @click="validateInput"
                >
                  <span
                    style="
                      font-family: poppinssemibold;
                      font-size: 12px;
                      color: #fff;
                      text-transform: none;
                    "
                  >
                    Add Address
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-dialog v-model="editDialog" width="800" persistent>
      <v-layout wrap justify-center>
        <v-flex xs12>
          <v-card tile flat>
            <v-layout
              wrap
              justify-center
              px-8
              py-5
              style="background-color: #b6b6b626"
            >
              <v-flex xs11 text-left>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #393939;
                  "
                >
                  Edit Address
                </span>
              </v-flex>
              <v-flex xs1>
                <v-icon @click="editDialog = false" color="#000000"
                  >mdi-close</v-icon
                >
              </v-flex>
            </v-layout>
            <v-layout
              wrap
              justify-center
              pt-8
              px-5
              style="
                font-size: 14px;
                color: #1f1f1f;
                font-family: RobotoRegular;
              "
            >
              <v-flex xs12 sm6 text-left px-2>
                <span>First Name </span>
                <v-text-field
                  ref="firstname"
                  placeholder="First Name"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.fstname"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span>Last Name </span>
                <v-text-field
                  ref="firstname"
                  placeholder="Last Name"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.lstname"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm12 text-left px-2>
                <span> Email </span>
                <v-text-field
                  ref="email"
                  placeholder="Email"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 text-left px-2>
                <span>Address </span>
                <v-text-field
                  ref="address"
                  placeholder="Address"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.address"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 sm6 text-left px-2>
                <span> City </span>
                <v-text-field
                  ref="city"
                  placeholder="City"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.city"
                ></v-text-field>
              </v-flex> -->
              <!-- <v-flex xs12 sm6 text-left px-2>
                <span> District </span>
                <v-text-field
                  ref="district"
                  placeholder="District"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.district"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span> State </span>
                <v-select
                  ref="state"
                  placeholder="State"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  item-text="name"
                  item-value="value"
                  :items="states"
                  :rules="[rules.required]"
                  v-model="editItem.state"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span> Country </span>
                <v-text-field
                  ref="country"
                  placeholder="Country"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.country"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs12 sm6 text-left px-2>
                <span>Pincode</span>
                <v-text-field
                  ref="pincode"
                  placeholder="Pincode"
                  background-color="#F5F5F5"
                  solo
                  flat
                  type="number"
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.zip"
                  @change="getPinCodeEdit"
                ></v-text-field>
                <!-- <v-text-field
                  ref="pincode"
                  placeholder="Pincode"
                  background-color="#F5F5F5"
                  solo
                  flat
                  type="number"
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.zip"
                
                ></v-text-field> -->
              </v-flex>
              
              <v-flex xs12 sm6 text-left px-2>
                <span>District</span>
                <v-text-field
                  ref="district"
                  placeholder="District"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.district"
            
                ></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 text-left px-2>
                <span>State</span>
                <v-text-field
                  ref="state"
                  placeholder="State"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.state"
             
                ></v-text-field>
              </v-flex>
              
              
              
              
              
              
              <v-flex xs12 sm6 text-left px-2>
                <span> Country </span>
                <v-text-field
                  ref="country"
                  placeholder="Country"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.country"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span> Landmark </span>
                <v-text-field
                  ref="landmark"
                  placeholder="Landmark"
                  background-color="#F5F5F5"
                  solo
                  flat
                 
                  dense
                  :rules="[rules.required]"
                  v-model="editItem.landmark"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 text-left px-2>
                <span> Phone </span>
                <v-text-field
                  ref="phone"
                  placeholder="Phone"
                  background-color="#F5F5F5"
                  solo
                  flat
                  dense
                  type="number"
                  :rules="[rules.required]"
                  v-model="editItem.mobile"
                ></v-text-field>
              </v-flex>
             
            </v-layout>
            <v-layout wrap justify-center py-5>
              <v-flex xs4 px-2 text-center>
                <v-btn
                  :ripple="false"
                  depressed
                  block
                  rounded
                  color="#444645"
                  @click="editAddress"
                >
                  <span
                    style="
                      font-family: poppinssemibold;
                      font-size: 12px;
                      color: #fff;
                      text-transform: none;
                    "
                  >
                    Edit Address
                  </span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-layout wrap justify-center>
      <v-flex xs11 pt-5>
        <v-layout wrap>
          <v-flex xs12 sm6 md8 text-left>
            <span
              style="
                color: #1f1f1f;
                font-family: poppinssemibold;
                font-size: 20px;
              "
              >Address</span
            >
          </v-flex>
          <v-flex xs12 py-4>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center v-if="list.length > 0" pt-5 pb-2>
          <v-flex xs12 py-2 v-for="(item, i) in list" :key="i">
            <v-card>
              <v-layout wrap justify-center py-5 px-8>
                <v-flex xs2 sm1 md1 lg1>
                  <v-radio-group
                    :hide-details="true"
                    v-model="item.isdefault"
                    column
                  >
                    <v-radio
                      @click="changeDefault(item)"
                      color="#30B868"
                      :value="true"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs10 sm11 text-left>
                  <v-layout wrap justify-start fill-height>
                    <v-flex xs12 sm6 md5 lg4 text-left>
                      <v-layout
                        wrap
                        justify-start
                        style="line-height: 16px"
                        fill-height
                      >
                        <v-flex xs12>
                          <span
                            style="
                              font-family: poppinssemibold;
                              font-size: 15px;
                              color: #000000;
                            "
                          >
                            {{ item.fstname }}
                            {{ item.lstname }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-3>
                          <span
                            style="
                              color: #191919;
                              font-size: 13px;
                              font-family: poppinsmedium;
                            "
                            >{{ item.address }} {{ item.city }},
                            {{ item.district }}, {{ item.state }}, {{ item.country }}, {{ item.zip }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <span
                            style="
                              color: #191919;
                              font-size: 13px;
                              font-family: poppinsmedium;
                            "
                            >
                            <v-icon size="17px" color="green">
                              mdi-phone
                            </v-icon> : &nbsp;{{ item.mobile }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <span
                            style="
                              color: #191919;
                              font-size: 13px;
                              font-family: poppinsmedium;
                            "
                            > <v-icon size="17px" color="green">
                              mdi-email
                            </v-icon> : &nbsp; {{ item.email }}
                          </span>
                        </v-flex>
                        <v-flex xs12 pt-2>
                          <span
                            style="
                              color: #191919;
                              font-size: 13px;
                              font-family: poppinsmedium;
                            "
                            ><v-icon size="17px" color="green">
                             mdi-map-marker-outline
                            </v-icon> : &nbsp;  {{ item.landmark }}
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 md5 lg8>
                      <v-layout wrap justify-end pt-3>
                        <v-flex xs6 sm6 md1 align-self-end text-right>
                          <v-icon
                            @click="(editDialog = true), (editItem = item)"
                            color="#49A1F2"
                            >mdi-pencil</v-icon
                          >

                          <!-- <v-btn
                            outlined
                            small
                            color="#49A1F2"
                            @click="(editDialog = true), (editItem = item)"
                            ><span
                              style="
                                color: #49a1f2;
                                font-family: poppinsregular;
                              "
                            >
                              edit</span
                            ></v-btn
                          > -->
                        </v-flex>
                        <v-flex xs6 sm6 md1 align-self-end text-right>
                          <v-dialog
                            v-model="item.dialogDelete"
                            max-width="600px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon color="#EC6D6D" v-on="on" v-bind="attrs"
                                >mdi-trash-can</v-icon
                              >
                              <!-- <v-btn
                                outlined
                                small
                                color="#EC6D6D"
                                v-on="on"
                                v-bind="attrs"
                                ><span
                                  style="
                                    color: #ec6d6d;
                                    font-family: poppinsregular;
                                  "
                                >
                                  Remove</span
                                ></v-btn
                              > -->
                            </template>
                            <v-card>
                              <v-card-title
                                style="
                                  font-family: poppinsregular;
                                  font-size: 15px;
                                  color: #000;
                                "
                                >Are you sure you want to delete this
                                Address?</v-card-title
                              >
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  small
                                  @click="item.dialogDelete = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="blue darken-1"
                                  text
                                  small
                                  @click="removeAddress(item)"
                                  >OK</v-btn
                                >
                                <v-spacer></v-spacer>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center pt-5 v-else>
          <v-flex xs12 pa-2 align-self-center>
            <span
              style="
                font-family: poppinsregular;
                font-size: 18px;
                color: #000000;
                cursor: pointer;
              "
              >Oops! No Address Available</span
            >
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 py-4>
            <v-divider></v-divider>
          </v-flex>
          <v-layout wrap justify-start pb-5>
            <v-flex xs12 sm6 md4 text-left>
              <v-btn
                elevation="0"
                rounded
                color="#444645"
                dark
                @click="addressAddDialog = true"
                ><span
                  style="
                    font-family: poppinsregular;
                    text-transform: capitalize;
                  "
                  >+ new address</span
                ></v-btn
              >
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      ServerError: false,
      timeout: 5000,
      msg: null,
      addressAddDialog: false,
      editDialog: false,
      selected: false,
      editItem: "",
      fstname: null,
      lstname: null,
      address: null,
      mobileNum:null,
      city: null,
      district: null,
      state: null,
      country: null,
      pincode: null,
      landmark:null,
      phone: null,
      email:null,
      list: [],
      states: [],
      pincodeArray:[],
      rules: {
        required: (value) => !!value || "Required.",
        min: (value) => value.length >= 8 || "Min 8 characters",
      },
    };
  },
  computed: {
    form() {
      return {
        firstname: this.fstname,
        lastname:this.lstname,
        address: this.address,
        //city: this.city,
        district: this.district,
        state: this.state,
        country: this.country,
        pincode: this.pincode,
        landmark: this.landmark,
        mobileNo: this.mobileNum,
        email: this.email,
      };
    },
    //   userData()
    //   {
    //     return this.$store.state.userData
    //   }
    // appUserId() {
    //   return this.$store.state.id;
    // },
    // UserId() {
    //   return this.$store.state.userId;
    // },
    appUserId: {
      get() {
        return localStorage.getItem("id"); // Get user ID from localStorage
      },
      set(value) {
        localStorage.setItem("id", value); // Save user ID to localStorage
      }
    },
    UserId: {
      get() {
        return localStorage.getItem("userId"); // Get user userId from localStorage
      },
      set(value) {
        localStorage.setItem("userId", value); // Save user ID to localStorage
      }
    }
  },
  created() {
  this.appUserId = localStorage.getItem("id"); // Retrieve user ID from localStorage
  if (this.appUserId) {
    this.getAddress(); // Call getUser only if the user ID is available
  }
},
  beforeMount() {
    this.getAddress();
    this.getState();
    //this.getPinCode();
  },
  watch:{
    pincode(newPincode) {
    if (!newPincode) {
      this.district = ''; // Clear district if pincode is empty
      this.state = '';    // Clear state if pincode is empty
    } else {
      this.getPinCode();
    }
  },
  'editItem.zip': function(newVal) {
      if (newVal) {
        this.getPinCodeEdit(); // Call getPinCode when pincode changes
      }
    }
},
  methods: {
    validateInput() {
      this.formHasErrors = false;
      var phoneformat = /^\d{10}$/;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) {
          this.formHasErrors = true;
          this.msg = "Please Provide " + f;
          this.showSnackBar = true;
          return;
        }
        // if (!this.$refs[f].validate(true)) {
        //   this.msg = "Please Provide Valid " + f;
        //   this.showSnackBar = true;
        //   this.formHasErrors = true;
        //   return;
        // }
      });
      if (!this.mobileNum.match(phoneformat)) {
        this.msg = "Please Provide valid Phone Number";
        this.showSnackBar = true;
        return;
      }
      if (this.formHasErrors == false) this.addAddress();
    },
    getAddress() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/address/view",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id:localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.appLoading = false;
            if (response.data.data) {
              this.list = response.data.data;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getState() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/states/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            if (response.data.data) {
              this.states = response.data.data;
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    addAddress() {
      this.appLoading = true;
      var address = {};
      address["fstname"] = this.fstname;
      address["lstname"] = this.lstname;
      address["address"] = this.address;
      //address["city"] = this.city;
      address["district"] = this.district;
      address["state"] = this.state;
      address["country"] = this.country;
      address["pincode"] = this.pincode;
      address["mobileNum"] = this.mobileNum;
      address["landmark"] = this.landmark;
      address["email"] = this.email;
      // address["id"] = this.appUserId;
      // address["guestId"] = this.UserId;
      address["id"] = localStorage.getItem("id");
      address["guestId"] = localStorage.getItem("userId");
      axios({
        method: "POST",
        url: "/user/address/addEdit",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: address,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.fstname = null;
            this.lstname = null;
            this.address = null;
            //this.city = null;
            this.district = null;
            this.state = null;
            this.country = null;
            this.pincode = null;
            this.mobileNum = null;
            this.email = null;
            this.landmark=null;
            this.addressAddDialog = false;
            this.getAddress();
            window.location.reload();
          } else {
          this.appLoading = false;
            this.msg = "Something went wrong";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    editAddress() {
      this.appLoading = true;
      var address = {};
      address["addressId"] = this.editItem.addressId;
      // address["id"] = this.appUserId;
      // address["guestId"] = this.UserId;
      address["id"] = localStorage.getItem("id");
      address["guestId"] = localStorage.getItem("userId");
      address["fstname"] = this.editItem.fstname;
      address["lstname"] = this.editItem.lstname;
      address["address"] = this.editItem.address;
      //address["city"] = this.editItem.city;
      address["district"] = this.editItem.district;
      address["state"] = this.editItem.state;
      address["country"] = this.editItem.country;
      address["landmark"] = this.editItem.landmark;
      address["pincode"] = this.editItem.zip;
      address["mobileNum"] = this.editItem.mobile;
      address["email"] = this.editItem.email;
      axios({
        method: "POST",
        url: "/user/address/addEdit",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: address,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.editDialog = false;
            this.getAddress();
          } else {
          this.appLoading = false;
            this.msg = "Something went wrong";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    changeDefault(item) {
      this.appLoading = true;
      var address = {};
      // address["id"] = this.appUserId;
      // address["guestId"] = this.UserId;
      address["id"] = localStorage.getItem("id");
      address["guestId"] = localStorage.getItem("userId");
      address["addressId"]=item.addressId
      address["isdefault"]=true
      axios({
        method: "POST",
        url: "/user/address/defaultChange",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: address,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.getAddress();
          } else {
          this.appLoading = false;
            this.msg = "Something went wrong";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    removeAddress(item) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/address/remove",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          addressId: item.addressId,
          id:localStorage.getItem("id"),
          guestid:localStorage.getItem("userId"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.dialogDelete = false;
            this.getAddress();
          } else {
          this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getPinCode() {
  if (!this.pincode) {
    this.district = '';
    this.state = '';
    return; // Exit early if pincode is empty
  }

  this.appLoading = true;
  axios({
    url: "/user/address/pincode",
    method: "POST",
    headers: {
      token: localStorage.getItem("token"),
    },
    data: {
      pincode: this.pincode,
    },
  })
    .then((response) => {
      this.appLoading = false;
      const pinData = response.data.data;
      if (pinData) {
        this.district = pinData.district; // Autofill district
        this.state = pinData.stateName;   // Autofill state
      }
    })
    .catch((err) => {
      this.appLoading = false;
      this.ServerError = true;
      console.error(err);
    });
},

    getPinCodeEdit() {
  if (!this.editItem.zip) return; // Ensure pincode is valid before calling the API
  axios({
    url: "/user/address/pincode",
    method: "POST",
    headers: {
      token: localStorage.getItem("token"),
    },
    data: {
      pincode: this.editItem.zip, // Send the pincode to the API
    },
  })
  .then((response) => {
    const pinData = response.data.data;
    if (pinData) {
      // Update the editItem with the fetched district and state values
      this.editItem.district = pinData.district;
      this.editItem.state = pinData.stateName;
    }
  })
  .catch((err) => {
    console.error(err);
  });
}

  },
};
</script>